import axios from "axios";

import { API_BASE_URL } from "../../config";

const baseUrl = `${API_BASE_URL}/api/web/settings`;

const authConfig = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export async function getTimeOffTypes(token) {
  const response = await axios.get(`${baseUrl}/types`, authConfig(token));
  return response.data;
}

export async function createAbsenceType(token, payload) {
  const response = await axios.post(`${baseUrl}/absence-types`, payload, authConfig(token));
  return response.data;
}

export async function updateAbsenceType(token, id, payload) {
  const response = await axios.put(`${baseUrl}/absence-types/${id}`, payload, authConfig(token));
  return response.data;
}

export async function deleteAbsenceType(token, id) {
  const response = await axios.delete(`${baseUrl}/absence-types/${id}`, authConfig(token));
  return response.data;
}

export async function createHolidayType(token, payload) {
  const response = await axios.post(`${baseUrl}/holiday-types`, payload, authConfig(token));
  return response.data;
}

export async function updateHolidayType(token, id, payload) {
  const response = await axios.put(`${baseUrl}/holiday-types/${id}`, payload, authConfig(token));
  return response.data;
}

export async function deleteHolidayType(token, id) {
  const response = await axios.delete(`${baseUrl}/holiday-types/${id}`, authConfig(token));
  return response.data;
}
